// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__17Y78","rootCenter":"LoadMoreObserver_rootCenter__1W4D_","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3JI3D"};